<template>
  <footer class="footer">
    <div class="footer__items">
      <div class="footer__item" v-for="block in blocks" :key="block.title">
        <p>{{block.title}}</p>
        <ul>
          <li v-for="item in block.items" :key="item.name">
            <a
              v-if="item.route.startsWith('http')"
              :href="item.route"
              class="link link--light-grey"
            >
              {{ item.name }}
            </a>
            <router-link
              v-else
              :to="{ path: item.route }"
              class="link link--light-grey"
            >
              {{item.name}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      blocks: [
        {
          title: 'Om oss',
          items: [
            { name:'Om Pension on Demand', route:'https://pensionondemand.se/om-oss/' },
            { name: 'Mina sidor', route: '/settings' },
            { name: 'Behandling av personuppgifter', route: 'https://pensionondemand.se/behandling-av-personuppgifter/' },
          ]
        },
        {
          title: 'Följ oss',
          items: [
            { name: 'Facebook', route: '/info' },
            { name: 'Instagram', route: '/info' }
          ]
        },
        {
          title: 'Kontakta oss',
          items:[
            { name: 'Kundservice', route: 'https://pensionondemand.se/kundservice/' },
          ]
        },
      ]
    }
  }
}
</script>
